import * as React from 'react';
import BaseComponent from '../BaseComponent';
import {Button, Card, CardBody, CardHeader, Col, FormGroup, Input, Label, Modal, Row} from "reactstrap";
import modelImageDefault from '../../assets/img/banner/rack.png';
import * as PropTypes from 'prop-types';
// import label from "../../message/Label"
import label from 'enqc-utilities/src/label/Label'

import MyCardImage from "../Card/MyCardImage";
import ModalCardHeader from "../Widget/ModalCardHeader";
// import ModalCardHeader from "../../../../administrator/src/components/Widget/ModalCardHeader";
// import ModelDetailPage from "../../../../administrator/src/pages/ModelDetailPage";


/*= (message, okCallback, cancelCallback) =>*/
export default class ModelModal extends BaseComponent{

    constructor(props){
        super(props);
        this.state = {
            model:this.props.model
        }
    }
    componentWillReceiveProps(props, nextContext) {
        if(this.props!==props){
            this.setState({
                model:props.model
            })
        }
    }


    render(){
        let {model} = this.state
        let modelCategory = model.modelCategory?model.modelCategory:{}
        let groupForm = model.groupForm?model.groupForm:{}
        let componentGroup = model.componentGroup??{}
        let releaseVerificationGroupForm = model.releaseVerificationGroupForm??{}
        return (
            <>
                {super.render()}
                <Modal
                    autoFocus={false}
                    // style={{minWidth:'80%'}}
                    size="xl"
                    centered={true}
                    isOpen={this.props.show}
                    backdrop={true}>
                    <Card>
                        <ModalCardHeader
                            content={(
                                <React.Fragment>
                                    <h3 style={{display:'contents'}}>{label.ModelInformation}</h3>
                                    <div
                                        style={{float:"right", textAlign:'right'}}>
                                        <Button
                                            className="btn-white-normal"
                                            color="none"
                                            onClick={() => {
                                                this.props.onClickOk()
                                            }}>{label.Close}</Button>
                                    </div>
                                </React.Fragment>
                            )}/>
                        <CardBody>
                            <Row>
                                <Col md={3} style={{textAlign:'left'}}>
                                    <Row>
                                        <Col>
                                            <Card>
                                                <CardBody>
                                                    <MyCardImage src={model.iconPhotoUrl??modelImageDefault}></MyCardImage>
                                                </CardBody>
                                            </Card>
                                        </Col>
                                    </Row>
                                </Col>
                                <Col md={9}>
                                    <Row>
                                        <Col>
                                            <FormGroup>
                                                <Label for="systemType">{label.SystemType}</Label>
                                                <Input
                                                    type="text"
                                                    name="systemType"
                                                    readOnly={true}
                                                    value={model.systemType}
                                                />
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col>
                                            <FormGroup>
                                                <Label for="modelName">{label.Name}</Label>
                                                <Input
                                                    type="text"
                                                    name="modelName"
                                                    readOnly={true}
                                                    value={model.modelName}
                                                />
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col>
                                            <FormGroup>
                                                <Label for="category">{label.Category}</Label>
                                                <Input
                                                    type="text"
                                                    name="category"
                                                    readOnly={true}
                                                    value={modelCategory.name}
                                                />
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col>
                                            <FormGroup>
                                                <Label for="systemType">{label.PartNumber}</Label>
                                                <Input
                                                    type="text"
                                                    name="partNumber"
                                                    readOnly={true}
                                                    value={model.partNumber}
                                                />
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col>
                                            <FormGroup>
                                                <Label for="description">{label.Description}</Label>
                                                <Input
                                                    type="textarea"
                                                    style={{minHeight:'180px'}}
                                                    name="description"
                                                    readOnly={true}
                                                    value={model.description}
                                                />
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                        </CardBody>
                    </Card>
                </Modal>
            </>
        )
    }
}

ModelModal.propTypes = {
    show:PropTypes.bool.isRequired,
    model:PropTypes.object.isRequired,
    onClickOk:PropTypes.func.isRequired,
}
